module.exports = __webpack_public_path__ + "img/15.c7d19be.webp";